export const buttonGroup = {
    base: 'relative',
    variants: {
        size: {
            xs: '',
            sm: '',
            md: '',
            lg: '',
            xl: '',
        },
        orientation: {
            horizontal: 'inline-flex -space-x-px bg-white',
            vertical: 'flex flex-col border -space-y-px bg-white',
        },
    },
}
